import { Outlet, useNavigate } from "@tanstack/react-router";
import { useAtomValue } from "jotai";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { LoadingOverlay } from "@/components/LoadingOverlay";
import { Toolbar } from "@/components/Toolbar";
import { auth } from "@/firebase";
import { currentUserAtom } from "@/modules/auth/auth.atoms";
import { AddModelDialog } from "@/modules/plus/data/components/AddModelDialog";
import { EditTemplateDialog } from "@/modules/plus/data/components/EditTemplateDialog";
import { ModelSheet } from "@/modules/plus/models/components/ModelSheet";
import { ReportDialog } from "@/modules/plus/reports/components/ReportDialog";

// App chrome for every authed route — everything the old Next.js root layout
// contributed: toolbar, loading overlay, the globally-mounted dialogs (so the
// underlying page state survives opens), and the toaster.
export const AppLayout: React.FC = () => {
  const user = useAtomValue(currentUserAtom);
  const navigate = useNavigate();

  // The authed route's beforeLoad guards the initial navigation; this covers
  // signing out (or session revocation) while the app is open. Double-check
  // auth.currentUser because the atom's first value can lag the subscription.
  useEffect(() => {
    if (user === null && !auth.currentUser) {
      navigate({ to: "/sign-in" });
    }
  }, [user, navigate]);

  return (
    <>
      <LoadingOverlay />
      <div className="flex h-full flex-col">
        <Toolbar />
        <div className="min-h-0 flex-1">
          <Outlet />
        </div>
      </div>
      <ModelSheet />
      <AddModelDialog />
      <EditTemplateDialog />
      <ReportDialog />
      <Toaster />
    </>
  );
};
